import { useCallback } from 'react';

import { useProcessorSchedulingGenerateCutsheetRequestMutation } from 'lib/graphql';
import { downloadFromBase64Encoded } from 'lib/downloadFromBase64Encoded';
import { downloadFromPresignedUrl } from 'lib/downloadFromPresignedUrl';

export function useDownloadCutsheetPdf() {
  const [generateCutsheetRequest, { loading: generatingPdf }] =
    useProcessorSchedulingGenerateCutsheetRequestMutation();

  const downloadPdf = useCallback(
    async (processorSchedulingId: string, cutsheetRequestId: string) => {
      const result = await generateCutsheetRequest({
        variables: { processorSchedulingId, cutsheetRequestId },
      });

      const resp = result.data?.processorSchedulingGenerateCutsheetRequest;
      if (resp?.fileUrl) {
        downloadFromPresignedUrl(resp.fileUrl);
      } else if (resp?.file && resp?.filename) {
        downloadFromBase64Encoded(resp.file, resp.filename);
      }
    },
    [generateCutsheetRequest],
  );

  return { generatingPdf, downloadPdf };
}
